// extracted by mini-css-extract-plugin
export default {"tabs":"T9-z","tablist":"U9-z","tablistItem":"V9-z"};